import { getTenant, getTenantLanguage } from 'utils/getTenantSpecificValues'
import * as Sentry from '@sentry/react'
import type { LanguageCodes } from 'locales/loadi18n'
import type { TenantLanguages, Tenants } from 'entities/Config'

const getLanguageCodeForTenantLanguage = () => {
  const tenant = getTenant()
  const language = getTenantLanguage()

  const languageCodeMap: Record<
    Tenants,
    Partial<Record<TenantLanguages, LanguageCodes>>
  > = {
    'com': {
      'de': 'de-DE',
    },
    'at': {
      'de': 'de-AT',
    },
    'be': {
      'nl': 'nl-BE',
      'fr': 'fr-BE',
    },
    'it': {
      'it': 'it-IT',
    },
    'erx': {
      'de': 'de-DE',
    },
  }

  const languageCode = languageCodeMap[tenant]?.[language]

  if (!languageCode) {
    Sentry.captureException(
      new Error(
        `Language code not found for tenant ${tenant} and language ${language}`
      )
    )
    return 'de-DE' // Ultimate fallback when document lang and tenant mapping unavailable
  }

  return languageCode
}

export default getLanguageCodeForTenantLanguage
